import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import CustomText from "./typography/CustomText";

export default function SearchComponent({
  searchWord = "",
  placeholder = "",
  className = "",
  searchType = "all",
  onChange = () => {},
  onChangeSearchWord = () => {},
  onKeyDown = () => {},
  onBlur = () => {},
}) {
  return (
    <div className="flex items-center">
      <FormControl sx={{ mr: 1, minWidth: 100, background: "#fff" }}>
        <InputLabel className="bold text-sm mt-0.5">Search Type</InputLabel>
        <Select
          size="small"
          name="searchType"
          value={searchType}
          label={
            <CustomText className="mt-2" bold>
              Custom Type
            </CustomText>
          }
          onChange={onChange}
        >
          {[
            { label: "All", id: "all" },
            { label: "Id", id: "id" },
            { label: "Name", id: "name" },
            { label: "Address", id: "address" },
          ].map((item, index) => (
            <MenuItem value={item?.id ?? "all"} key={index}>
              {item?.label ?? ""}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        className={`my-1 ${className}`}
        // value={searchWord}
        // onChange={onChangeSearchWord}
        onBlur={onBlur}
        onKeyDown={(e) => {
          if (e.key === "Enter") onKeyDown(e);
        }}
        id="outlined-basic"
        name="searchWord"
        label="Search"
        variant="outlined"
        size="small"
        placeholder={placeholder}
        style={{ width: 200 }}
        inputProps={{ style: { background: "#fff" } }}
      />
    </div>
  );
}

export const searchDataFc = ({
  row = {},
  searchType = "",
  searchWord = "",
}) => {
  let newStr = {};
  switch (searchType) {
    case "id":
      newStr = { orderId: row?.weekl_slot_id ?? "", subId: row?.id };
      break;
    case "name":
      newStr = { name: row?.name ?? "" };
      break;
    case "address":
      newStr = { address: row?.address?.label ?? "" };
      break;
    default:
      newStr = {
        id: row.id,
        name: row.name,
        address: row?.address?.label ?? "",
      };
      break;
  }
  let searchWords = searchWord.split(" "),
    s = 0,
    strObject = Object.values(newStr).join("");
  searchWords.forEach((t) => {
    if (strObject.toLowerCase().search(t.toLowerCase()) >= 0) s++;
  });
  if (s > 0) return true;
  else return false;
};
